import { createFileRoute } from "@tanstack/react-router";
import { MailOpen } from "lucide-react";

function InboxEmptyPane() {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-surface-subtle">
          <MailOpen className="h-5 w-5 text-text-muted" />
        </div>
        <h2 className="text-lg font-medium">No ticket selected</h2>
        <p className="mt-1 text-sm text-text-muted">Pick one from the list on the left.</p>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/_auth/inbox/")({
  component: InboxEmptyPane,
});
